// body: JSON da resposta 2xx (ou null); sentIds: ids enviados no lote
// Retorna { received: string[], rejected: {id, reason}[], unresolved: string[] }
export function classifyEventsResponse(body, sentIds) {
  const sent = new Set(sentIds)
  const hasReceived = Array.isArray(body?.received)
  const received = hasReceived ? body.received.filter((id) => sent.has(id)) : []
  const rejected = Array.isArray(body?.rejected)
    ? body.rejected
        .filter((r) => r && sent.has(r.id))
        .map((r) => ({ id: r.id, reason: String(r.reason ?? 'unknown') }))
    : []
  // Contrato legado: sem `received` nem `rejected` => tudo aceito.
  if (!hasReceived && rejected.length === 0) {
    return { received: [...sentIds], rejected: [], unresolved: [] }
  }
  const settled = new Set([...received, ...rejected.map((r) => r.id)])
  return {
    received,
    rejected,
    unresolved: sentIds.filter((id) => !settled.has(id)),
  }
}

// Agrega rejeições para um único evento `events_rejected`
export function summarizeRejections(rejected) {
  const reasons = {}
  for (const r of rejected) reasons[r.reason] = (reasons[r.reason] ?? 0) + 1
  return {
    count: rejected.length,
    reasons,
    sampleIds: rejected.slice(0, 3).map((r) => r.id),
  }
}
